// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importa los archivos de traducción
import translationEN from './locales/en/translations.json';
import translationES from './locales/es/translations.json';
import translationFR from './locales/fr/translations.json';
import translationDE from './locales/de/translations.json';

// Configura los recursos con los diferentes idiomas
const resources = {
    en: {
        translation: translationEN,
    },
    es: {
        translation: translationES,
    },
    fr: {
        translation: translationFR,
    },
    de: {
        translation: translationDE,
    },
};

// Función para verificar si hay consentimiento para cookies funcionales
const hasFunctionalConsent = () => {
    try {
        const preferences = JSON.parse(localStorage.getItem('cookiePreferences'));
        return preferences && preferences.functional;
    } catch {
        return false;
    }
};

// Detector de idioma personalizado que respeta el consentimiento
const customLanguageDetector = {
    name: 'customDetector',
    lookup() {
        // Si hay consentimiento, intentar obtener el idioma guardado
        if (hasFunctionalConsent()) {
            return localStorage.getItem('i18nextLng');
        }
        // Si no hay consentimiento, solo usar el idioma del navegador
        return navigator.language || navigator.userLanguage;
    },
    cacheUserLanguage(lng) {
        // Solo guardar el idioma si hay consentimiento
        if (hasFunctionalConsent()) {
            localStorage.setItem('i18nextLng', lng);
        }
    }
};

i18n
    // Detecta el idioma del navegador o de la cache (localStorage)
    .use(LanguageDetector)
    // Conecta i18next con React
    .use(initReactI18next)
    .init({
        resources,
        // Idioma por defecto en caso de no detectar ninguno (puedes elegir el que prefieras)
        fallbackLng: 'es',
        // Activa el modo debug en desarrollo
        debug: process.env.NODE_ENV === 'development',
        detection: {
            order: ['customDetector', 'navigator'],
            lookupLocalStorage: 'i18nextLng',
            caches: hasFunctionalConsent() ? ['localStorage'] : [],
        },
        interpolation: {
            // React ya se encarga de la seguridad contra XSS
            escapeValue: false,
        },
    });

// Función para limpiar el idioma guardado cuando se retira el consentimiento
export const clearLanguagePreference = () => {
    localStorage.removeItem('i18nextLng');
};

export default i18n;